var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurriculumTopicPractices = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#356A1C",
    d: "M35.96 28.42a.5.5 0 0 1-.69 0l-3.861-3.683a.5.5 0 0 1 0-.724l1.11-1.059a.5.5 0 0 1 .69 0l2.06 1.967a.5.5 0 0 0 .69 0l4.813-4.592a.5.5 0 0 1 .69 0l1.11 1.06a.5.5 0 0 1 0 .723zm-7.55-4.17a.5.5 0 0 0-.5-.5H17.12a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h10.79a.5.5 0 0 0 .5-.5zm12.72 7.862a.5.5 0 0 0 0-.724l-1.109-1.059a.5.5 0 0 0-.69 0l-2.716 2.592a.5.5 0 0 1-.69 0l-2.716-2.592a.5.5 0 0 0-.69 0l-1.11 1.06a.5.5 0 0 0 0 .723l2.648 2.526a.5.5 0 0 1 0 .724l-2.648 2.526a.5.5 0 0 0 0 .724l1.11 1.059a.5.5 0 0 0 .69 0l2.716-2.592a.5.5 0 0 1 .69 0l2.716 2.592a.5.5 0 0 0 .69 0l1.11-1.06a.5.5 0 0 0 0-.723l-2.648-2.526a.5.5 0 0 1 0-.724zM28.41 34.25a.5.5 0 0 0-.5-.5H17.12a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h10.79a.5.5 0 0 0 .5-.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurriculumTopicPractices);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/curriculum-topic-practices.17c75bddbf2eb5bcdb13d7ce81b2be8a.svg";